import Aura from '@primeuix/themes/aura';
import {definePreset} from '@primeuix/themes';

/**
 * KlausPreset – Poppy Klaus brand design system
 * PrimeNG v20 / Angular 20 compatible
 */
export const KlausPreset = definePreset(Aura, {
    primitive: {},

    semantic: {
        // ─────────────────────────────────────────────
        // COLOR FAMILIES  (50 → 950)
        // ─────────────────────────────────────────────
        primary: {
            50:  '#e6f1f6',
            100: '#cce3ed',
            200: '#b3d5e4',
            300: '#99c7db',
            400: '#80b9d2',
            500: '#66abc9',
            600: '#4d9dc0',
            700: '#338fb7',
            800: '#1a81ae',
            900: '#0073a5',
            950: '#005275'
        },

        red: {
            50:  '#fdf5f6',
            100: '#f7cfd2',
            200: '#f0a8af',
            300: '#e9828c',
            400: '#e35b68',
            500: '#dc3545',
            600: '#bb2d3b',
            700: '#9a2530',
            800: '#791d26',
            900: '#58151c',
            950: '#3d1013'
        },

        green: {
            50:  '#e8f5e9',
            100: '#c8e6c9',
            200: '#a5d6a7',
            300: '#81c784',
            400: '#66bb6a',
            500: '#4caf50',
            600: '#43a047',
            700: '#388e3c',
            800: '#2e7d32',
            900: '#1b5e20',
            950: '#0d3e0f'
        },

        yellow: {
            50:  '#fffef0',
            100: '#fff9c4',
            200: '#fff59d',
            300: '#fff176',
            400: '#ffee58',
            500: '#ffcc00',
            600: '#ffc400',
            700: '#ffb300',
            800: '#ffa000',
            900: '#ff8f00',
            950: '#ff6f00'
        },

        orange: {
            50:  '#fff3e0',
            100: '#ffe0b2',
            200: '#ffcc80',
            300: '#ffb74d',
            400: '#ffa726',
            500: '#ff9800',
            600: '#fb8c00',
            700: '#f57c00',
            800: '#ef6c00',
            900: '#e65100',
            950: '#bf360c'
        },

        cyan: {
            50:  '#e0f7fa',
            100: '#b2ebf2',
            200: '#80deea',
            300: '#4dd0e1',
            400: '#26c6da',
            500: '#00bcd4',
            600: '#00acc1',
            700: '#0097a7',
            800: '#00838f',
            900: '#006064',
            950: '#004d40'
        },

        pink: {
            50:  '#fce4ec',
            100: '#f8bbd0',
            200: '#f48fb1',
            300: '#f06292',
            400: '#ec407a',
            500: '#e91e63',
            600: '#d81b60',
            700: '#c2185b',
            800: '#ad1457',
            900: '#880e4f',
            950: '#6d0a3e'
        },

        purple: {
            50:  '#f3e5f5',
            100: '#e1bee7',
            200: '#ce93d8',
            300: '#ba68c8',
            400: '#ab47bc',
            500: '#9c27b0',
            600: '#8e24aa',
            700: '#7b1fa2',
            800: '#6a1b9a',
            900: '#4a148c',
            950: '#38006b'
        },

        slate: {
            50:  '#eceff1',
            100: '#cfd8dc',
            200: '#b0bec5',
            300: '#90a4ae',
            400: '#78909c',
            500: '#607d8b',
            600: '#546e7a',
            700: '#455a64',
            800: '#37474f',
            900: '#263238',
            950: '#1a252b'
        },

        amber: {
            50:  '#fffbea',
            100: '#fff3c4',
            200: '#ffe99a',
            300: '#ffdd6b',
            400: '#ffd740',
            500: '#ffd700',
            600: '#ffc400',
            700: '#ffab00',
            800: '#ff9100',
            900: '#ff6d00',
            950: '#e65100'
        },
        bluegray:{
             50:'#f7f9f9',
            100:'#d9e0e3',
            200:'#bbc7cd',
            300:'#9caeb7',
            400:'#7e96a1',
            500:'#607d8b',
            600:'#526a76',
            700:'#435861',
            800:'#35454c',
            900:'#263238'
        },
        // ─────────────────────────────────────────────
        // COLOR SCHEMES  (Light + Dark)
        // ─────────────────────────────────────────────
        colorScheme: {
            light: {
                primary: {
                    color: '{primary.900}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.700}',
                    activeColor: '{primary.800}'
                },
                surface: {
                    0: '#ffffff',
                    50: '#f8fafc',
                    100: '#f1f5f9',
                    200: '#e2e8f0',
                    300: '#cbd5e1',
                    400: '#94a3b8',
                    500: '#64748b',
                    600: '#475569',
                    700: '#334155',
                    800: '#1e293b',
                    900: '#0f172a',
                    950: '#020617'
                }
            },

            dark: {
                primary: {
                    color: '{primary.300}',
                    contrastColor: '#0f172a',
                    hoverColor: '{primary.200}',
                    activeColor: '{primary.100}'
                },
                surface: {
                    0: '#0f172a',
                    50: '#1e293b',
                    100: '#334155',
                    200: '#475569',
                    300: '#64748b',
                    400: '#94a3b8',
                    500: '#cbd5e1',
                    600: '#e2e8f0',
                    700: '#f1f5f9',
                    800: '#f8fafc',
                    900: '#ffffff'
                }
            }
        }
    }
});
